/**
 * errorHandler is a singleton which allows users to log errors and get a list of subscribers.
 * It initializes the subscribers if they haven't already been initialized and does so only
 * once per instance.
 */
const errorHandler = (function handlerFactory() {
  return {
    getSubscribers() {
      return errorHandler.errorSubscribers || {};
    },
  };
})();

function initializeErrorHandler(BUGSNAG_CONFIG_PAYLOAD_KEY) {
  if (typeof errorHandler.errorSubscribers !== 'undefined') {
    return;
  }
  errorHandler.errorSubscribers = {};
  if (typeof window === 'undefined') {
    return;
  }
  if (
    typeof errorHandler.errorSubscribers.bugsnagClient === 'undefined' &&
    typeof window.bugsnag !== 'undefined' &&
    !window.bugsnag.initialized
  ) {
    const config = BUGSNAG_CONFIG_PAYLOAD_KEY;
    if (config) {
      errorHandler.errorSubscribers.bugsnagClient = window.bugsnag(config);
    }
  } else if (typeof window.bugsnag !== 'undefined') {
    errorHandler.errorSubscribers.bugsnagClient = window.bugsnag.client;
  }
  if (
    typeof errorHandler.errorSubscribers.newrelic === 'undefined' &&
    typeof window.newrelic !== 'undefined'
  ) {
    errorHandler.errorSubscribers.newrelic = window.newrelic;
  }
  errorHandler.errorSubscribers.user = (err, msg, metaData) => {
    // eslint-disable-next-line no-console
    console.error(err.toString(), msg, metaData);
  };
}

function tellBugsnag(err, msg, metaData = {}) {
  try {
    const client = errorHandler.getSubscribers().bugsnagClient;
    if (client) {
      const { BugsnagReport } = client;
      const handledState = {
        severity: 'warning',
        unhandled: false,
        severityReason: {
          type: 'handledException',
        },
      };
      const report = new BugsnagReport(
        err.name,
        msg ? `${err.message} - ${msg}` : err.message,
        BugsnagReport.getStacktrace(err),
        handledState
      );

      report.updateMetaData('extra', metaData);
      client.notify(report);
    }
  } catch (doNothingWithError) {
    console.log(doNothingWithError); // eslint-disable-line
  }
}

function tellNewRelic(err) {
  try {
    const client = errorHandler.getSubscribers().newrelic;
    if (client) {
      client.noticeError(err);
    }
  } catch (doNothingWithError) {
    // eslint-disable-next-line no-console
    console.log(doNothingWithError);
  }
}

function tellUser(err, msg, metaData) {
  const client = errorHandler.getSubscribers().user;
  if (client) {
    client(err, msg, metaData);
  }
}

/**
 *
 * @param {Error} err - Error object
 * @param {string} msg - {optional extra message}
 * @param {Object} metaData - [optional metadata object]
 */
errorHandler.logError = function logError(err, ...rest) {
  if (!err) return;
  let [message, metaData] = rest;
  if (typeof rest[0] === 'object' && rest.length === 1) {
    message = null;
    [metaData] = rest;
  }

  tellBugsnag(err, message, metaData);
  tellNewRelic(err, message, metaData);
  tellUser(err, message, metaData);
};

module.exports = {
  errorHandler,
  initializeErrorHandler,
};
